<template>
  <div>
    <div :id="mapId" class="map-canvas"></div>
  </div>
</template>

<script>
import initMapMixin from '../../../mixins/initMapMixin';

export default {
  mixins: [initMapMixin],
  props: {
    plots: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      markers: [],
    };
  },

  computed: {
    plotsCount() {
      return this.plots.length;
    },
  },

  watch: {
    plotsCount(newValue, oldValue) {
      this.loadPlotsOnMap(this.plots.slice(oldValue, newValue));
    },
  },

  methods: {
    loadPlotsOnMap(plots) {
      plots.forEach((plot) => {
        this.addMarker(plot);
      });
    },

    mapLoaded() {
      this.$emit('mapLoaded');
    },

    clearMarkers() {
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
      this.markers = [];
    },

    async addMarker(plot) {
      let marker = new this.google.maps.Marker({
        position: { lat: plot.latitude, lng: plot.longitude },
        draggable: false,
        editable: false,
        map: this.map,
        animation: this.google.maps.Animation.DROP,
        title: `${plot.name}, ${plot.field.name}`,
      });

      this.markers.push(marker);

      this.addClickListener(plot, marker);
    },

    addClickListener(plot, marker) {
      const vm = this;
      let lastInfoWindow = null;

      this.google.maps.event.addListener(marker, 'click', async () => {
        if (!marker.info) {
          try {
            const { info } = await this.getLocationInfo(plot.latitude, plot.longitude);
            marker.info = info;
          } catch (e) {
            marker.info = null;
          }
        }

        let infoWindow = new this.google.maps.InfoWindow({
          content: vm.infoWindowTemplate(plot, marker),
        });

        if (lastInfoWindow) {
          lastInfoWindow.close();
        }

        infoWindow.open(this.map, marker);
        lastInfoWindow = infoWindow;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.map-canvas {
  height: 100vh;
}
</style>
